
import { defineComponent, PropType } from 'vue'
import { Subscription, User } from '@/api/tripply/models'
import { getUserColor } from '@/api/tripply/tools'

export default defineComponent({
  props: {
    user: Object as PropType<User>,
    subscription: Object as PropType<Subscription>,
    size: String as PropType<'small'|'large'>
  },
  setup(props) {
    return { getUserColor }
  },
})
